import _ from 'underscore';
import {v4 as uuidv4} from 'uuid';

import {
  DataTableColumn,
  DataTableConfig,
  DEFAULT_DEFAULT_VALUE,
} from 'notebook/data-tables/DataTableConstants';
import {makeSchemaFieldStructuredColumn} from 'notebook/structured-tables/util/StructuredTableColumnUtil';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';
import {NoteLinkedObjectType} from 'notebook/util/NoteUtilConstants';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {getPrimaryLinkField} from 'results/PrimaryLinks';
import {DEFAULT_MIN_COLUMN_WIDTH} from 'runs/Columns';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';

export function convertFieldsToColumns(
  assaySchema: AssaySchema,
  selectorsById: {[selectorId: string]: SchemaFieldSelector}
): Array<DataTableColumn> {
  const columns: Array<DataTableColumn> = [];
  const primaryField = getPrimaryLinkField(assaySchema);

  for (const field of assaySchema.fields) {
    if (field === primaryField) {
      continue;
    }
    columns.push(makeSchemaFieldStructuredColumn(field, selectorsById, undefined, assaySchema.allFields));
  }

  const fieldsLength = assaySchema.fields.length;
  if (columns.length === 0 && ((primaryField && fieldsLength === 1) || fieldsLength === 0)) {
    columns.push({
      provenanceUuid: uuidv4(),
      columnType: TableColumnType.STRING,
      name: 'Untitled',
      cid: _.uniqueId('dtcol'),
      tagSchemaFieldId: null,
      defaultValue: DEFAULT_DEFAULT_VALUE,
      width: DEFAULT_MIN_COLUMN_WIDTH,
      isReadOnly: false,
      isProtected: false,
      isRequired: false,
      isArchived: false,
      isReported: true,
    });
  }

  return columns;
}

// Keep in sync with
// benchling/workflows/data_tables/publish_data_table_config.py::_convert_schema_to_data_table_config
export default function convertAssaySchemaToDataTableConfig(
  assaySchema: AssaySchema,
  selectorsById: {[selectorId: string]: SchemaFieldSelector}
): DataTableConfig {
  const columns = convertFieldsToColumns(assaySchema, selectorsById);
  const primaryField = getPrimaryLinkField(assaySchema);

  return {
    cid: _.uniqueId('dtc'),
    type: NoteLinkedObjectType.DATA_TABLE_CONFIG,
    name: assaySchema.name,
    provenanceUuid: uuidv4(),
    isStandalone: true,
    isWatchingInputTable: false,
    watchedRegistrationProvenanceUuids: [],
    linkType: primaryField ? primaryField.fieldType : null,
    assaySchema,
    columns,
  };
}
